export const LOGIN_PATH = "/";
export const FORGOT_PASSWORD_PATH = "/forgot-password";
export const RESET_PASSWORD_PATH = "/reset-password";
export const SET_PASSWORD_PATH = "/set-password";

// Account
export const ACCOUNT_PATH = "/account";

// System Users
export const SYSTEM_USERS_PATH = "/core/system-users";
export const SYSTEM_USERS_ADD_PATH = "/core/system-users/add-or-update";
export const SYSTEM_USERS_UPDATE_PATH = "/core/system-users/add-or-update/:id";

// Audit Logs
export const AUDIT_LOGS_PATH = "/core/audit-logs";
export const AUDIT_LOG_DETAILS_PATH = "/core/audit-logs/detail";

// Default SEO
export const DEFAULT_SEO_PATH = "/core/default-seo";

// Sitemap & Robots
export const SITEMAP_PAGE_PATH = "/core/sitemap";
export const SITEMAP_PAGE_ADD_PATH = "/core/sitemap/add-or-update";
export const SITEMAP_PAGE_UPDATE_PATH = "/core/sitemap/add-or-update/:id";
export const ROBOTS_PAGE_PATH = "/core/robots";

// Mall
export const MALL_PAGE_PATH = "/pages/mall";
export const MALL_PAGE_ADD_PATH = "/pages/mall/add-or-update";
export const MALL_PAGE_UPDATE_PATH = "/pages/mall/add-or-update/:id";

// Brands
export const BRANDS_CATEGORIES_PAGE_PATH = "/pages/brands/categories";
export const BRANDS_LISTING_PATH = "/pages/brands/listing";
export const BRANDS_LISTING_ADD_PATH = "/pages/brands/listing/add-or-update";
export const BRANDS_LISTING_UPDATE_PATH =
  "/pages/brands/listing/add-or-update/:id";
export const FOOD_MAIN_PAGE = "/pages/brands/food";
export const PREMIUM_MAIN_PAGE = "/pages/brands/premium";
export const BRANDS_MAIN_PAGE = "/pages/brands/main";

// Offers
export const OFFERS_PAGE_PATH = "/pages/offers/listing";
export const OFFERS_PAGE_ADD_PATH = "/pages/offers/listing/add-or-update";
export const OFFERS_PAGE_UPDATE_PATH =
  "/pages/offers/listing/add-or-update/:id";
export const OFFERS_MAIN_PAGE_PATH = "/pages/offers/main";

// Cashback
export const CASHBACK_PAGE_PATH = "/pages/cashbacks/listing";
export const CASHBACK_PAGE_ADD_PATH = "/pages/cashbacks/listing/add-or-update";
export const CASHBACK_PAGE_UPDATE_PATH =
  "/pages/cashbacks/listing/add-or-update/:id";
export const CASHBACK_MAIN_PAGE_PATH = "/pages/cashbacks/main";

// News
export const NEWS_PAGE_PATH = "/pages/news/listing";
export const NEWS_PAGE_ADD_PATH = "/pages/news/listing/add-or-update";
export const NEWS_PAGE_UPDATE_PATH = "/pages/news/listing/add-or-update/:id";
export const NEWS_MAIN_PAGE_PATH = "/pages/news/main";

// Vacancy
export const VACANCY_PAGE_PATH = "/pages/vacancy/listing";
export const VACANCY_PAGE_ADD_PATH = "/pages/vacancy/listing/add-or-update";
export const VACANCY_PAGE_UPDATE_PATH =
  "/pages/vacancy/listing/add-or-update/:id";
export const VACANCY_MAIN_PAGE_PATH = "/pages/vacancy/main";

// Services
export const SERVICES_PAGE_PATH = "/pages/services/listing";
export const SERVICES_PAGE_ADD_PATH = "/pages/services/listing/add-or-update";
export const SERVICES_PAGE_UPDATE_PATH =
  "/pages/services/listing/add-or-update/:id";
export const SERVICES_MAIN_PAGE_PATH = "/pages/services/main";

// Reviews
export const REVIEWS_PAGE_PATH = "/pages/reviews/listing";
export const REVIEWS_PAGE_ADD_PATH = "/pages/reviews/listing/add-or-update";
export const REVIEWS_PAGE_UPDATE_PATH =
  "/pages/reviews/listing/add-or-update/:id";
export const REVIEWS_MAIN_PAGE_PATH = "/pages/reviews/main";

// Map
export const MAP_MAIN_PAGE_PATH = "/pages/map/main";

export const MAP_FLOOR_PAGE_PATH = "/pages/map/floors";
export const MAP_FLOOR_PAGE_ADD_PATH = "/pages/map/floors/add-or-update";
export const MAP_FLOOR_PAGE_UPDATE_PATH = "/pages/map/floors/add-or-update/:id";

export const MAP_PIN_PAGE_SELECT_FLOOR_PATH =
  "/pages/map/pins/select-floor/:floorId";

export const MAP_PIN_PAGE_PATH = "/pages/map/pins";
export const MAP_PIN_PAGE_ADD_PATH =
  "/pages/map/pins/select-floor/add-or-update";
export const MAP_PIN_PAGE_UPDATE_PATH =
  "/pages/map/pins/select-floor/add-or-update/:mapFloorId/:id";

// Text Pages
export const PRIVACY_POLICY_PAGE_PATH = "/pages/privacy-policy";
export const COOKIES_POLICY_PAGE_PATH = "/pages/cookies-policy";
export const ADDITIONAL_INFORMATION_PAGE_PATH = "/pages/financial-report";
export const CITY_TOWER_PAGE_PATH = "/pages/city-tower";
export const MAGIC_CITY_PAGE_PATH = "/pages/magic-city";
export const TERMS_AND_CONDITIONS_PAGE_PATH = "/pages/terms-and-conditions";
export const LOYALTY_USER_TERMS_AND_CONDITIONS_PAGE_PATH =
  "/pages/loyalty-user-terms-and-conditions";

// Card
export const CARDS_MAIN_PAGE_PATH = "/pages/cards/main";
export const CARDS_PAGE_PATH = "/pages/cards/listing";
export const CARDS_PAGE_ADD_PATH = "/pages/cards/listing/add-or-update";
export const CARDS_PAGE_UPDATE_PATH = "/pages/cards/listing/add-or-update/:id";
export const CITY_MALL_CARD_PAGE_PATH = "/pages/cards/city-mall-card";

// Loyalty Card
export const LOYALTY_CARD_PAGE_PATH = "/pages/loyalty-card/card";
export const LOYALTY_BENEFITS_PAGE_PATH = "/pages/loyalty-benefits";

// General
export const GENERAL_PAGE_PATH = "/pages/general";

// Contact
export const CONTACT_PAGE_PATH = "/pages/contact";

// Homepage
export const HOME_MAIN_PAGE_PATH = "/pages/homepage/main";
export const HOME_MAIN_SLIDER_PAGE_PATH = "/pages/homepage/listing";
export const HOME_PAGE_BRANDS = "/pages/homepage/brands";
export const HOME_MAIN_SLIDER_PAGE_ADD_PATH =
  "/pages/homepage/listing/add-or-update";
export const HOME_MAIN_SLIDER_PAGE_UPDATE_PATH =
  "/pages/homepage/listing/add-or-update/:id";
export const HOMEPAGE_BRANDS_LISTING_PATH = "/pages/homepage/brands-listing";
export const HOMEPAGE_EVENTS_PAGE_PATH = "/pages/homepage/events";
export const HOMEPAGE_EVENTS_PAGE_ADD_PATH =
  "/pages/homepage/events/add-or-update";
export const HOMEPAGE_EVENTS_PAGE_UPDATE_PATH =
  "/pages/homepage/events/add-or-update/:id";
export const HOMEPAGE_SPECIAL_EVENT_PATH = "/pages/homepage/special-event";

// Landing Page
export const LANDING_PAGE_PATH = "/pages/landing";
